module.exports = __webpack_public_path__ + "img/dm.e5f54952.svg";